/* === NEW FILE: src/pages/courses/MyCoursesPage.js === */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const CourseCard = ({ course }) => {
    const linkPath = course.course_type === 'live' 
        ? `/live-courses/${course.id}` 
        : `/courses/${course.id}`;

    return (
        <div className="course-card">
            <img src={course.thumbnail} alt={course.title} className="course-card-image"/>
            <div className="course-content">
                {course.course_type === 'live' && <span className="course-status live-course">LIVE</span>}
                <h3>{course.title}</h3>
                <div className="course-meta">
                    <div className="meta-item">
                        <span className="material-icons">{course.course_type === 'live' ? 'event' : 'play_lesson'}</span>
                        <span>{course.category}</span>
                    </div>
                </div>
                <Link to={linkPath} className="course-button">
                    {course.course_type === 'live' ? 'View Details' : 'Continue Learning'}
                </Link>
            </div>
        </div>
    );
};

const MyCoursesPage = () => {
    const [courses, setCourses] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCourses = async () => {
            const token = localStorage.getItem('app_token');
            try {
                const response = await axios.get('/api/users/my-courses', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setCourses(response.data);
            } catch (err) {
                setError("Failed to load your courses.");
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };
        fetchCourses();
    }, []);
    
    const liveCourses = courses.filter(c => c.course_type === 'live');
    const selfPacedCourses = courses.filter(c => c.course_type === 'self-paced');

    if (isLoading) return <p>Loading your courses...</p>;
    if (error) return <p className="error-message">{error}</p>;

    return (
        <div>
            <h2 className="section-title">My Live Courses</h2>
            {liveCourses.length > 0 ? (
                <div className="courses-list">
                    {liveCourses.map(course => <CourseCard key={`live-${course.id}`} course={course} />)}
                </div>
            ) : (
                <p>You are not registered for any upcoming live courses.</p>
            )}

            <h2 className="section-title" style={{ marginTop: '2.5rem' }}>My Self-Paced Courses</h2>
            {selfPacedCourses.length > 0 ? (
                <div className="courses-list">
                    {selfPacedCourses.map(course => <CourseCard key={`self-${course.id}`} course={course} />)}
                </div>
            ) : (
                <p>You have not enrolled in any self-paced courses yet.</p>
            )}
        </div>
    );
};

export default MyCoursesPage;
